export function isFulfillmentAdminUser(): boolean {
  const userRole = localStorage.getItem('user_role');
  const roleCode = localStorage.getItem('role_code');
  return userRole === '30' || roleCode === 'FULFILLMENT_ADMIN';
}

export function postLoginRoute(): string {
  return isFulfillmentAdminUser() ? '/fulfillmentadmin/vendor-list' : '/programs';
}
